import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@cancercentrum/rcc-bootstrap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
export const LoadingAlert = ()=>{
    return /*#__PURE__*/ _jsx(Alert, {
        bsStyle: "info",
        icon: faSpinner,
        iconProps: {
            spin: true
        },
        children: " Laddar, var god vänta..."
    });
};
